import {Injectable} from '@angular/core';
import {HttpClient, HttpParams} from "@angular/common/http";
import {environment} from "../../environments/environment";
import {map} from "rxjs/operators";

@Injectable({
  providedIn: 'root'
})
export class IntegrationService {
  urlOperator = environment.api.suppliers;
  urlRecharge = environment.api.recharges;
  urlPackage = environment.api.packages;
  urlBuyPackage = environment.api.buyPackage;
  urlPackageSuppliers = environment.api.packagesSuppliers;
  urlPackageCategories = environment.api.packagesCategories;
  urlProductCategories= environment.api.productsCategories;
  urlMetabase= environment.api.metabaseToken;

  urlIntegrations = environment.api.integrations  //url del microservicio

  constructor(private http: HttpClient) {

  }

  registerImageShops(files, typePhotos, entityId) {
    const formData = new FormData();

    files.forEach((photo, index) => {
      if(photo) {
        console.log('itero con:', photo);
        
        formData.append('typePhotos', typePhotos[index]);
        if (Array.isArray(photo.name)) {
          console.log('La propiedad name de la imagen es un array, por lo tanto de aqui tomo los datos de la imagen para el backend');
          formData.append('files', photo.name[0]);
        } else {
          console.log('La propiedad name de la imagen NO es un array, Se toma el objeto completo la imagen para el backend');
          formData.append('files', photo);
        }
      } else {
        console.log('no existe la foto en integrations', index);
      }
    });

    console.log('quiero guardar con:', formData);

    const url = this.urlIntegrations.concat('upload-file/',entityId);
    return this.http.post(url, formData)
    .pipe(map(results => results));
  }

  getImages(body) {
    const url = this.urlIntegrations.concat('/extract-images');
    return this.http.post(url, body)
      .pipe(map(results => results));
  }

  getSuppliers() {
    return this.http.get(this.urlOperator)
      .pipe(map(results => results));
  }

  buyRecharge(body) {
    return this.http.post(this.urlRecharge, body)
      .pipe(map(results => results));
  }

  getPackageSuppliers() {
    return this.http.get(this.urlPackageSuppliers)
      .pipe(map(results => results));
  }

  getPackageCategories(supplierCode: string) {
    return this.http.post(this.urlPackageCategories,{supplierCode})
      .pipe(map(results => results));
  }

  getPackages(categoryCode) {
    return this.http.post(this.urlPackage, {categoryCode})
      .pipe(map(results => results));
  }

  buyPackage(body) {
    return this.http.post(this.urlBuyPackage, body)
      .pipe(map(results => results));
  }

  getProductCategory() {
    return this.http.get(this.urlProductCategories,{})
      .pipe(map(results => results));
  }

  getMetabaseToken(questionId: number, userId: string) {
    const params = new HttpParams()
    .set('questionId', questionId.toString())
    .set('userId', userId);

  return this.http.post<string>(this.urlMetabase , null, {
     params: params,
     responseType: 'text' as 'json'
    });
  }
}
